import loadable from "@loadable/component";

import { ErrorBoundary } from "../../../components";
import loadData from "../data";
import { RouteComponentProps } from "react-router";
import FullPageLoader from "@Components/FullPageLoader";
import useSearch from "../useSearch";

const SearchDesktop = loadable(() => import("./SearchDesktop"), {
  fallback: <FullPageLoader />,
});

const SearchDesktopV2 = loadable(() => import("./SearchDesktopV2"), {
  fallback: <FullPageLoader />,
});

const NotFound = loadable(() => import("@Pages/NotFound"), {
  fallback: <FullPageLoader />,
});

const SearchRegionDesktop = loadable(() => import("./SearchRegionDesktop"), {
  fallback: <FullPageLoader />,
});

export default (props: RouteComponentProps): JSX.Element => {
  const { isError, showRegionPage, isStatus500, isInternalUser, showFullPageLoader } =
    useSearch(props);

  if (isError) {
    return <NotFound isStatus500={isStatus500} {...props} />;
  }

  if (showFullPageLoader) {
    return <FullPageLoader />;
  }

  if (showRegionPage) {
    return (
      <ErrorBoundary>
        <SearchRegionDesktop />
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary>
      <SearchDesktopV2 isAgentView={isInternalUser} />
    </ErrorBoundary>
  );
};

export { SearchDesktop as PreFetchSearch };
export { loadData };
